import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { ArrowRight } from "lucide-react";

import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "components/ui/table";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";

const EmployeeRecordValue = ({ rows }) => {
  const navigate = useNavigate();

  return (
    <div className="overflow-hidden rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[80px]">ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Questions</TableHead>
            <TableHead>Response</TableHead>
            <TableHead>Updated</TableHead>
            <TableHead>Next</TableHead>
            <TableHead className="w-[60px]"><span className="sr-only">Actions</span></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows && rows.map((row, i) => {
            const hasResponse = Array.isArray(row?.response?.pillars) && row?.response?.pillars?.length > 0;
            return (
              <TableRow key={i}>
                <TableCell className="font-mono text-xs text-muted-foreground">{row?.id}</TableCell>
                <TableCell className="font-medium">{row?.name}</TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  <ArrayDisplay items={row?.question_sort_order || []} />
                </TableCell>
                <TableCell>
                  <Badge variant={hasResponse ? "secondary" : "destructive"}>
                    {hasResponse ? "Yes" : "No"}
                  </Badge>
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {row?.updated_at ? format(new Date(row?.updated_at), "dd-MMM-yyyy hh:mm") : "—"}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {row?.run_next_on ? format(new Date(row?.run_next_on), "dd-MMM-yyyy hh:mm") : "—"}
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="icon"
                    aria-label="View details"
                    onClick={() => navigate(`/app/survey-standard/details/${row?.id}`)}
                  >
                    <ArrowRight className="h-4 w-4" />
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

EmployeeRecordValue.propTypes = {
  rows: PropTypes.array.isRequired,
};

export default EmployeeRecordValue;

const ArrayDisplay = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return <span className="text-muted-foreground">[]</span>;
  return (
    <div className="truncate">
      [
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <span className="tabular-nums">{item}</span>
          {index !== items.length - 1 && ", "}
        </React.Fragment>
      ))}
      ]
    </div>
  );
};
